import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-accent" />
      <div className="footer-content">
        <div className="footer-main">
          <div className="footer-brand">
            <h3>Harris County Historical Society</h3>
            <p>Preserving and sharing Harris County's heritage since 1923.</p>
          </div>
          <div className="footer-links">
            <h4>Quick Links</h4>
            <nav aria-label="Footer navigation">
              <Link to="/about">About</Link>
              <Link to="/events">Events</Link>
              <Link to="/media">Media</Link>
              <Link to="/support">Membership</Link>
              <Link to="/contact">Contact</Link>
            </nav>
          </div>
          <div className="footer-contact">
            <h4>Get in Touch</h4>
            <p>PO Box 55776<br />Houston, TX 77255-5776</p>
            <a href="mailto:harriscountyhistoricalsociety@gmail.com" className="footer-email">
              harriscountyhistoricalsociety@gmail.com
            </a>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Harris County Historical Society &middot; harriscountyhistory.org</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
